<template>
  <b-loading
    :model-value="active"
    :is-full-page="isFullPage"
    :can-cancel="canCancel"
    :animation="animation"
    :on-cancel="onCancel"
    @close="onClose"
  >
    <slot />
  </b-loading>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'LoadingView',
  emits: ['close'],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    isFullPage: {
      type: Boolean,
      default: true
    },
    canCancel: {
      type: Boolean,
      default: false
    },
    animation: {
      type: String,
      default: 'fade'
    },
    onCancel: {
      type: Function,
      default: null
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    }
  }
};
</script>
